import React from 'react';
import { useCss } from 'app/utils/css';
import { ButtonA, ColorScheme } from './ButtonClassNameA';
import { ExtractProps } from '../../../utils/types';
import LoadingButtonA from './LoadingButtonA';
import FacebookLogoSquare from 'app/components/svgs/social/FacebookLogoSquare';

interface IProps extends ExtractProps<typeof ButtonA> {
  isLoading: boolean;
}

const FacebookButton: React.SFC<IProps> = ({ children, ...rest }) => {
  const css = useCss();

  return (
    <LoadingButtonA
      {...rest}
      colorScheme={ColorScheme.Facebook}
    >
      <div
        className={css('center', {
          // Align the button with the content so the button aligns in the event of wrapping.
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
        })}
      >
        <FacebookLogoSquare
          className={css('logo', {
            // Don't let the logo size change.
            flexShrink: 0,
            fill: '#fff',
            width: '19px',
            height: '19px',
            marginRight: '8px',
          })}
        />
        {children}
      </div>
    </LoadingButtonA>
  );
};

export default FacebookButton;
